var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sim",
    transform: "translate(0 20) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M0,2.531A2.516,2.516,0,0,1,2.5,0H14.31a2.484,2.484,0,0,1,1.767.743l3.192,3.23A2.547,2.547,0,0,1,20,5.761V24.469A2.516,2.516,0,0,1,17.5,27H2.5A2.516,2.516,0,0,1,0,24.469Zm2.5-.844a.839.839,0,0,0-.833.844V24.469a.839.839,0,0,0,.833.844h15a.839.839,0,0,0,.833-.844V5.761a.849.849,0,0,0-.243-.6L14.9,1.934a.828.828,0,0,0-.588-.246Z",
    transform: "translate(0 0)",
    fill: "#00105c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M2.448,1.659a.823.823,0,0,0-.816.829V4.976h4.08V1.659Zm4.9,0V4.976h4.08V2.488a.823.823,0,0,0-.816-.829Zm4.08,4.976H1.632V9.952h9.793Zm0,4.976H7.345v3.317h3.264a.823.823,0,0,0,.816-.829ZM5.713,14.927V11.61H1.632V14.1a.823.823,0,0,0,.816.829ZM0,2.488A2.468,2.468,0,0,1,2.448,0h8.161a2.468,2.468,0,0,1,2.448,2.488V14.1a2.468,2.468,0,0,1-2.448,2.488H2.448A2.468,2.468,0,0,1,0,14.1Z",
    transform: "translate(3.471 5.207)",
    fill: "#00105c",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSim);
export default __webpack_public_path__ + "static/media/sim.1e1169e900c5b01651cc6172a9d419d5.svg";
export { ForwardRef as ReactComponent };